<template>
  <form>
    <div class="errors">
      <ul>
        <li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
      </ul>
    </div>
    <div class="form-container text-right">
      <div class="md-layout text-left">
        <div class="md-layout-item md-small-size-100 md-size-20">
          <form-group
            label="First Name"
            input-type="text"
            :validator-object="$v.newUser.firstName"
          ></form-group>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-20">
          <form-group
            label="Last Name"
            input-type="text"
            :validator-object="$v.newUser.lastName"
          ></form-group>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-30">
          <form-group
            label="Mobile (Optional)"
            input-type="tel"
            :validator-object="$v.newUser.phone"
          ></form-group>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-30">
          <form-group
            label="Email Address"
            input-type="email"
            :validator-object="$v.newUser.email"
          ></form-group>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-35">
          <form-group
            label="Business Role"
            :validator-object="$v.newUser.businessRole"
          >
            <template v-slot:input
              ><md-select v-model="$v.newUser.businessRole.$model" md-dense>
                <md-option value="employee">Employee</md-option>
                <md-option value="manager">Business Manager</md-option>
              </md-select></template
            >
            <span v-if="!$v.newUser.businessRole.required"
              >You must select an option</span
            >
          </form-group>
        </div>
      </div>
    </div>
    <div
      class="md-layout-item md-size-100 text-center d-flex align-items-center justify-content-center"
    >
      <md-button
        class="md-primary"
        type="submit"
        :disabled="loading"
        @click.prevent="addUser()"
      >
        Add Employee to Business
      </md-button>
      <md-progress-spinner
        class="mx-3"
        :md-diameter="30"
        :md-stroke="loading ? 4 : 0"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
  </form>
</template>
<script>
import ApiService from "@/services/api";
import userModel from "@/models/user";
import { required, email } from "vuelidate/lib/validators";
import FormGroup from "@/components/Forms/FormGroup";
import { toastLaravelErrors } from "@/mixins";

export default {
  name: "RegistrationFormAbbr",
  components: { FormGroup },
  mixins: [toastLaravelErrors],
  data() {
    return {
      newUser: this.initUser(),
      errors: [],
      loading: false
    };
  },
  validations: {
    newUser: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      phone: {},
      email: {
        required,
        email
      },
      businessRole: {
        required
      }
    }
  },
  created() {
    ApiService.auth.setCSRF();
  },
  methods: {
    addUser() {
      this.errors = [];

      if (!this.validate()) return;

      this.loading = true;

      const userData = {
        first_name: this.newUser.firstName,
        last_name: this.newUser.lastName,
        email: this.newUser.email,
        mobile_number: this.newUser.phone,
        manager: this.newUser.businessRole === "manager"
      };

      ApiService.business
        .addUserToBusiness(userData)
        .then(() => {
          this.initUser();
          this.$nextTick(() => {
            this.$v.$reset();
          });
          this.$emit("userAdded");
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.toastLaravelErrors(error);
          } else if (error.response.status === 409) {
            this.$toast.error(
              "A user with the given email already belongs to another business and is registered."
            );
          } else {
            this.$toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initUser() {
      return (this.newUser = Object.assign({}, userModel));
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    }
  }
};
</script>
<style lang="scss" scoped>
.form-container {
  .md-layout {
    border: 1px dashed #77b3a2;
    border-top: none;
    padding: 1rem;
  }
  &:first-child {
    .md-layout {
      border-top: 1px dashed #77b3a2;
    }
  }
}
</style>
